import { useRef } from "react";
import { ReactComponent as UploadIcon } from "../../assets/icons/form/upload-icon.svg";
import { ReactComponent as WhiteArrow } from "../../assets/icons/arrows/white-arrow-right.svg";
import { useState, useEffect } from "react";

interface Props {
  label?: string;
  value?: File | null;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  labelClassName?: string;
  error?: boolean;
  imageUrl?: string;
  roundedImage?: boolean;
  accept?: string;
  showHeader?: boolean;
  showNextButton?: boolean;
  showFooterProgress?: boolean;
  resizeType?: string;
}

export const AppFormUpload = ({
  label,
  value,
  onChange,
  labelClassName,
  error,
  imageUrl,
  roundedImage,
  accept = ".svg, .png, .jpg, .gif",
  showHeader,
  showNextButton,
  showFooterProgress,
  resizeType,
}: Props) => {
  /** Refs */
  const fileInputRef = useRef(null);
  /** State */
  const [imagePath, setImagePath] = useState<string | null>(null);

  const handleUploadClick = () => {
    if (fileInputRef?.current) {
      // @ts-ignore
      fileInputRef?.current?.click();
    }
  };

  useEffect(() => {
    if (value) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePath(reader.result as string);
      };
      reader.readAsDataURL(value);
      return;
    }
    if (imageUrl) {
      return setImagePath(imageUrl);
    }
  }, [value, imageUrl]);

  return (
    <div className="mb-4">
      <p
        className={`font-satoshi text-dark text-sm font-medium mb-3 ${labelClassName}`}
      >
        {label}
      </p>
      <div
        onClick={handleUploadClick}
        className={`w-full py-[29px] flex flex-col justify-center items-center border border-dashed ${
          error ? "border-red-base border-2" : "border-primary-base border"
        } rounded bg-sky-lighter cursor-pointer`}
      >
        {imagePath ? (
          <div className="phone-frame">
            {/* Phone Frame Container */}
            <div className="relative w-[280px] h-[580px] bg-black rounded-[45px] p-3 shadow-lg">
              {/* Phone Notch */}
              <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-[120px] h-[25px] bg-black rounded-b-[20px] z-20"></div>
              {/* Phone Screen */}
              <div className="w-full h-full bg-white rounded-[35px] overflow-hidden">
                {showHeader ? (
                  <div className="absolute right-7 top-7 font-satoshi font-medium text-blue-gray-700">
                    Skip
                  </div>
                ) : null}
                <img
                  src={imagePath}
                  alt="uploaded"
                  className={`w-full h-full object-${resizeType ?? "contain"}`}
                />
                {showFooterProgress ? (
                  <div className="flex flex-row items-center absolute bottom-12 ml-7">
                    <div className="w-4 h-2 rounded-full bg-yellow" />
                    <div className="w-2 h-2 rounded-full bg-[#D3D3D3] ml-1" />
                    <div className="w-2 h-2 rounded-full bg-[#D3D3D3] ml-1" />
                    <div className="w-2 h-2 rounded-full bg-[#D3D3D3] ml-1" />
                  </div>
                ) : null}
                {showNextButton ? (
                  <div className="flex flex-row items-center justify-center absolute bottom-9 right-7 bg-[#FF6E41] rounded-full p-2">
                    <WhiteArrow />
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        ) : (
          <div className="phone-frame">
            {/* Phone Frame Container */}
            <div className="relative w-[280px] h-[580px] bg-black rounded-[45px] p-3 shadow-lg">
              {/* Phone Notch */}
              <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-[120px] h-[25px] bg-black rounded-b-[20px] z-20"></div>
              {/* Phone Screen */}
              <div className="w-full h-full bg-gray-border rounded-[35px] overflow-hidden flex items-center justify-center flex-col">
                <UploadIcon className="mb-4" />
                <div className="flex flex-row items-center">
                  <p className="font-satoshi text-sm font-medium text-primary-base">
                    Click to upload
                  </p>
                  <p className="font-satoshi text-sm font-medium text-gray-text ml-1">
                    or drag and drop
                  </p>
                </div>
                <p className="font-satoshi text-sm font-medium text-gray-text">
                  SVG, PNG, JPG or GIF
                </p>
                <p className="font-satoshi text-sm font-medium text-gray-text">
                  (max, 800 X 800px)
                </p>
              </div>
            </div>
          </div>
        )}
        <input
          type="file"
          ref={fileInputRef}
          className="hidden"
          accept={accept}
          onChange={onChange}
        />
      </div>
    </div>
  );
};
